import React from "react"

function DefaultPermissions({ sharedInformation, clientName }) {
  const toItemList = (sharedInfo) =>
    sharedInfo.map((item) => {
      const { info, list } = item
      let { desc } = item

      // override client info
      if (info.toLowerCase() === "balance") {
        desc = `View your ${clientName} balance`
      } else if (info.toLowerCase() === "msisdn") {
        desc = `${clientName} mobile number`
      } else if (info.toLowerCase() === "profile") {
        desc = `Get the following information`
      }

      // if sublist exists
      if (list) {
        return (
          <li key={info}>
            {desc}
            <ul> {toItemList(list)}</ul>
          </li>
        )
      }
      return <li key={info}>{desc}</li>
    })

  const infoList = toItemList(sharedInformation)

  return (
    <div className="container">
      <ul>{infoList}</ul>
    </div>
  )
}

export default DefaultPermissions
